export { default } from './src/PaymentVariants';
export type { Variant as PaymentVariantType } from './src/types';
